export default "__VITE_ASSET__8H5NcTjk__"